const Mission = () =>
  import(/* webpackChunkName: "Mission" */ "@/components/ssp/missions/Mission.vue");

import MissionCommon from "@/router/common-routes/mission/mission-common";
import SSPMissionCommonChildrens from "@/router/common-routes/mission/children/mission-common-childrens";
import { useMissionStore } from "@/store/modules/mission";

const setCurrentMission = async (to, from, next) => {
  const missionsStore = useMissionStore();
  if (to.params.missionId !== from.params.missionId) {
    await missionsStore.retrieveMission(to.params.missionId);
  }
  next();
};

export default [
  ...MissionCommon,
  {
    path: ":missionId",
    component: Mission,
    children: SSPMissionCommonChildrens,
    beforeEnter: setCurrentMission,
  },
];
